import { Box } from '@mui/material';

const masterColumn = (renderRigPhotoCell) => [
  {
    field: 'Customer',
    headerName: 'Customer Name',
    width: 210,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'UserEmail',
    headerName: 'User Email',
    width: 250,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'comment',
    headerName: 'Comment',
    width: 300,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
    renderCell: (params) => (
      <Box whiteSpace='wrap'>
        {params.value}
      </Box>
    )
  },
  {
    field: 'lastUpdate',
    headerName: 'Date',
    width: 250,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'lat',
    headerName: 'Latitute',
    width: 200,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'long',
    headerName: 'Longitude',
    width: 200,
    editable: false,
    headerAlign: 'center',
    align: 'center',
    hide: false,
  },
  {
    field: 'rigPhotos',
    headerName: 'Rig Photos',
    renderCell: renderRigPhotoCell,
    headerAlign: 'center',
    align: 'center'
  },
];

export { masterColumn };
